export const SITE_NAME = 'DreamHack';

export const SITE_DESCRIPTION = 'DreamHack, the world\'s largest digital festival hosts a series of events around the world and attract over 300.000 gaming & esports enthusiasts annually. DreamHack events are the center of live broadcasts reaching millions of people and here you can find the upcoming ones.';

export const DEFAULT_META_IMAGE = 'https://dreamhack.com/img/facebook_meta.png';
